<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('index.cashInAndOut')" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs wh100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog h100p df">
          
          <div class="left f1 df-l-c-fs border">
            <InputCustom
              :inputable="true"
              :showPassword="false"
              inputWidth="340"
              :inputPlaceholder="$t('index.inputCash')"
              :inputValue="inputCount" />

            <Keyboard :inputValue.sync="inputCount" :decimalPlaces="{us:2,hk:1}[sysEnv_x]" priceModel showDoubleZero class="mt20" />
          </div>

          <div class="right f1 df-l-fs pl20 h100p">
            
            <div class="btns df-c-fs">
              <div class="" :class="typeSelected===1?'themebtn':'whitebtn'" @click="typeClick(1)">{{$t('index.cashIn')}}</div>
              <div class=" ml20" :class="typeSelected===2?'themebtn':'whitebtn'" @click="typeClick(2)">{{$t('index.cashOut')}}</div>
            </div>

            <div class="reason mt20">
              <div class="reason-title f-dark" :class="{'_redcolor':active}">{{$t('key.selectReason')}}</div>
              <div class="reason-content df-w-sb">
                <div v-for="(x,i) in reasons" :key="i" class="reason-item df" @click="reasonClick(x)">
                  <img style="width:20px;height:20px;margin-right:16px;" mode="aspectFill" :src="x.select?iconCheckok:iconChecknull" />
                  <div class="reason-label f-dark f-xs">{{x['name'+_lang]}}</div>
                </div>
              </div>
            </div>

            <div class="mt20" v-if="reasons_others_.select">
              <textarea class="textarea mytextarea" :placeholder="$t('index.inputOtherReason')" v-model="otherReasonText" />
            </div>

          </div>

        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogCashDrawer',
  data() {
    return {
      isShowDialog: false,
      inputCount: '',
      reasons_in: [],
      reasons_out: [],
      reasons_others: { name_zh: '其他', name_en: 'Others', id: -1, type: 3, select: false },
      typeSelected: 1,
      otherReasonText: '',
      active: false,
    }
  },
  computed: {
    reasons() {
      if (this.typeSelected === 1) {
        return this.reasons_in
      }
      return this.reasons_out
    },
    reasons_others_() {
      if (this.typeSelected === 1) {
        return this.reasons_in.find(x1 => x1.type === 3) || {}
      }
      return this.reasons_out.find(x1 => x1.type === 3) || {}
    },
  },
  methods: {
    // #region 对话框交互
    async open() {
      this.scan_canLeave_x_save(false)
      await this.getReasons()
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
      this.clear()
      this.typeSelected = 1
      // console.log(`%c:`, 'color: #00f;', this.currentRoute)
      // if (this.currentRoute === 'shop') {
      //   // 如果是在店铺营业状态页面，考虑是否需要刷新报告
      // }
    },
    clear() {
      this.otherReasonText = ''
      this.reasons.forEach(x1 => {
        x1.select = false
      })
      // this.reasons_others.select = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.inputCount = ''
    },
    // #endregion

    // #region 页面交互
    typeClick(val) {
      this.clear()
      this.typeSelected = val
      this.otherReasonText = ''
    },
    reasonClick(item) {
      // 多选
      // item.select = !item.select
      // 单选
      this.clear()
      item.select = true
    },
    async submit() {
      if (this.inputCount) {
        let reasonId = (this.reasons.find(x => x.select) || {}).id
        // console.log(`%c取消原因:`, 'color: #00f;', reasonId)
        if (reasonId) {
          if (reasonId === -1 && this.otherReasonText === '') {
            this.active = true
            return
          }
          this.active = false
          
          let rD = {
            shopId: this.currentShopId,
            cash: this.inputCount,
            type: this.typeSelected,
            reasonId,
            operateReasonOther: this.otherReasonText,
          }
          // console.log(`%crD:`, 'color: #f0f;', rD)
          const _D = await this.newData('cashAction', rD)
          if (_D) {

            this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')

            this.close()
            this.clear()
          }
        } else {
          this.active = true
        }
      }
    },
    // #endregion

    // #region 数据获取
    async getReasons() {
      const _R = await this.getData('cashReason', {
        shopId: this.currentShopId,
      })
      // console.log(`%c_R:`, 'color: #f00;', _R)
      _R.forEach(x1 => {
        x1.select = false
      })
      this.reasons_in = [
        ..._R.filter(x1 => x1.type === 1),
        JSON.parse(JSON.stringify(this.reasons_others))
      ]
      this.reasons_out = [
        ..._R.filter(x1 => x1.type === 2),
        JSON.parse(JSON.stringify(this.reasons_others))
      ]
    },
    // #endregion
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 30px 20px 0;box-sizing: border-box;
  .left{
    &.border{border-right: 1px solid #979797;}
  }
  .right{
    box-sizing: border-box;
    .btns{width: 340px;}
    .reason{
      width: 366px;
      &-title{padding: 10px 0;}
      &-item{width: 50%;padding: 10px 0;box-sizing: border-box;}
      &-label{line-height: 20px;}
    }
    .input{width: 280px;height: 40px;padding: 0 40px 0 10px;box-sizing: border-box;}
    .textarea{width: 366px;height: 120px;}
  }
}
</style>